module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-fit-w u-pad-y-1 u-relative"
  }, [(_vm.contentPage.code !== 404) ? _c('div', [(_vm.hasVideo()) ? _c('div', {
    staticClass: "c-page--container c-marg--before-footer u-relative"
  }, [_c('header', {
    staticClass: "c-article__head u-block u-relative u-marg-b-xl u-marg-t-xxxl@md u-marg-b-lg@md"
  }, [_c('h1', {
    staticClass: "t-h4 u-uppercase u-inline-block u-w5of9 u-valign-top u-fit-w@md",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-flex--x u-marg-b-lg u-flex--y@md"
  }, [(_vm.contentPage.languages.length > 0) ? _c('div', {
    staticClass: "u-flex__item--auto u-relative u-uppercase t-text--xs u-inline-block u-cursor-pointer u-marg-b-xs@md"
  }, [(_vm.currentLang) ? _c('a', {
    staticClass: "c-lang u-inline-block",
    on: {
      "click": _vm._onLangListClick,
      "mouseenter": _vm._onLangListOver
    }
  }, [_c('span', {
    staticClass: "u-inline-block u-marg-a-xs"
  }, [_c('img', {
    staticClass: "u-valign-bottom",
    attrs: {
      "src": _vm.getFlag(_vm.currentLang.slug),
      "width": "28",
      "height": "19",
      "alt": _vm.currentLang.name
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "u-inline-block u-valign-middle u-marg-l-xs",
    domProps: {
      "innerHTML": _vm._s(_vm.currentLang.name)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "c-lang-list"
    }
  }, [(_vm.langOpen) ? _c('ul', {
    staticClass: "c-lang-list o-list--none u-absolute u-pos-tl u-index--4 u-bg--gray-dark",
    on: {
      "mouseleave": _vm._onLangListLeave
    }
  }, _vm._l((_vm.contentPage.languages), function(lang) {
    return _c('li', {
      key: lang.id,
      staticClass: "c-lang o-list__item",
      on: {
        "click": function($event) {
          _vm.goto(_vm.currentRound.slug, lang.id)
        }
      }
    }, [_c('span', {
      staticClass: "u-inline-block u-marg-a-xs"
    }, [_c('img', {
      staticClass: "u-valign-bottom",
      attrs: {
        "src": _vm.getFlag(lang.slug),
        "width": "28",
        "height": "19",
        "alt": lang.name
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "u-inline-block u-valign-middle u-marg-l-xs",
      domProps: {
        "innerHTML": _vm._s(lang.name)
      }
    })])])
  })) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', _vm._l((_vm.roundsSameLang), function(round) {
    return _c('app-btn', {
      key: round.slug,
      staticClass: "c-btn--secondary u-align-center u-marg-x-xxxs u-marg-b-xxs@sm u-block@sm",
      attrs: {
        "to": _vm.getMatchUrl(round.slug)
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(round.name)
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticClass: "u-flex__item--auto u-hide@lg"
  })]), _vm._v(" "), _c('app-youtube', {
    staticClass: "u-marg-b-lg u-fit-w",
    attrs: {
      "id": _vm.currentRound.youtubeId,
      "autoplay": false
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "u-align-center"
  }, [_c('span', {
    staticClass: "u-valign-middle u-color--gray t-text--bold t-text--sm u-uppercase u-marg-r-xxs",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.footer)
    }
  })])], 1) : _c('div', {
    staticClass: "c-match-versus__no-match c-page--container c-marg--before-footer u-relative u-vacuum"
  }, [_c('div', {
    staticClass: "u-w1of2 u-inline-block u-valign-middle u-marg-b-xl u-fit-w@md u-align-center@md"
  }, [_c('img', {
    staticClass: "u-valign-middle u-marg-r-xs",
    attrs: {
      "src": _vm.getVideoGameFromID(_vm.contentPage.upcoming.videoGameID).logo_light,
      "width": "120"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-w1of2 u-inline-block u-align-right u-valign-middle u-marg-b-xl u-fit-w@md u-align-center@md"
  }, [_c('span', {
    staticClass: "t-text--xl t-lspacing--md u-marg-b-xs u-uppercase u-bold u-block",
    domProps: {
      "innerHTML": _vm._s(_vm.getUpcomminCounter())
    }
  }), _vm._v(" "), (_vm.getUpcommingDate()) ? _c('span', {
    staticClass: "t-text--sm u-color--gray-light t-lspacing--md u-uppercase u-marg-b-xs u-block",
    domProps: {
      "innerHTML": _vm._s(_vm.getUpcommingDate())
    }
  }) : _vm._e(), _vm._v(" "), _c('app-btn', {
    staticClass: "u-valign-middle u-marg-t-xxs",
    on: {
      "click": function($event) {
        _vm.openModalRegister()
      }
    }
  }, [_c('span', {
    staticClass: "c-register-btn-icon__container u-inline-block"
  }, [_c('img', {
    staticClass: "c-register-btn-icon__img u-absolute u-pos-l u-pos-y-center",
    attrs: {
      "src": require("../../../assets/icon/icon-register--arrow.png")
    }
  })]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.upcoming.support)
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "c-match-versus__container u-align-center u-flex--x u-flex--y@md u-flex--space-around@md"
  }, [_c('div', {
    staticClass: "u-inline-block u-flex__item--auto u-bold u-align-left u-flex__item--center u-relative u-index--2 u-flex__item--none@md"
  }, [_c('img', {
    staticClass: "c-match-versus__team-logo u-opacity--3 u-valign-middle u-marg-r-xxs",
    attrs: {
      "src": _vm.getTeamFromID(_vm.contentPage.upcoming.teamOneID).logotype,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "t-lspacing--sm u-line-height--sm u-valign-middle u-inline-block u-uppercase",
    domProps: {
      "innerHTML": _vm._s(_vm.getTeamFromID(_vm.contentPage.upcoming.teamOneID).name.replace(' ', '<br>'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-relative u-flex__item--center"
  }, [_c('img', {
    staticClass: "u-absolute c-match-versus__img-vs",
    attrs: {
      "src": require("../../../assets/versus/icon-hexagon-big.png"),
      "width": "328",
      "height": "368",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "t-text--xxl t-lspacing--sm u-color--red-pure u-valign-middle u-relative",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.upcoming.versus)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-inline-block u-flex__item--auto u-bold u-align-right u-flex__item--center u-relative u-flex__item--none@md"
  }, [_c('span', {
    staticClass: "t-lspacing--sm u-line-height--sm u-valign-middle u-inline-block u-uppercase u-marg-r-xxs",
    domProps: {
      "innerHTML": _vm._s(_vm.getTeamFromID(_vm.contentPage.upcoming.teamTwoID).name.replace(' ', '<br>'))
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "c-match-versus__team-logo u-opacity--3 u-valign-middle",
    attrs: {
      "src": _vm.getTeamFromID(_vm.contentPage.upcoming.teamTwoID).logotype,
      "alt": ""
    }
  })])])])]) : _c('app-season-coming-soon', {
    staticClass: "c-page--container c-marg--before-footer u-relative"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57398096"}!./src/scripts/components/page-match-details/template.html
// module id = 921
// module chunks = 0